"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _CardStyles = require("./CardStyles");
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  CardButton = props => {
    const {
        customClassNames,
        path,
        label,
        onClick,
        buttonTestId,
        variant = "ctalinkWithArrow",
        url
      } = props,
      buttonClasses = (0, _classnames.default)({
        "TextCard__button": true,
        [`${customClassNames}`]: (0, _string.isStringOfLength)(customClassNames)
      });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: buttonClasses,
      component: _reactRouterDom.Link,
      "data-testid": buttonTestId,
      onClick: onClick,
      to: path,
      variant: variant
    }, label), (0, _string.isStringOfLength)(label) && (0, _string.isStringOfLength)(url) && !(0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: buttonClasses,
      component: "a",
      "data-testid": buttonTestId,
      onClick: onClick,
      href: url,
      target: "_blank",
      variant: variant
    }, label));
  };

/**
 * Card with text, with row and column variant behavior
 *
 * @visibleName Text Card
 * @author Seraphim Sakiewicz
*/
const TextCard = props => {
  const {
      button,
      fragmentId,
      children,
      customContainerSx = {},
      customContentSx,
      customInnerContentSx,
      customTheme = {},
      text,
      title,
      variant = "left",
      // Test ID's
      testId,
      contentTestId,
      innerTestId,
      textTestId,
      titleTestId,
      subLandingColor,
      landingStyles
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    compiledClassNames = (0, _classnames.default)({
      "textCard": true,
      "textCard--left": variant === "left",
      "textCard--center": variant === "center"
    }),
    containerSx = merge.all([(0, _CardStyles.DefaultTextCardSx)(theme, subLandingColor, landingStyles, variant), customContainerSx]);
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: compiledClassNames,
    "data-testid": testId,
    sx: containerSx
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, {
    className: "textCard__content",
    "data-testid": contentTestId,
    sx: customContentSx
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "textCard__InnerContent",
    "data-testid": innerTestId,
    sx: customInnerContentSx
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, title && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    "data-testid": titleTestId,
    component: "h4",
    className: "heading--isCardHeading"
  }, title), text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    "data-testid": textTestId
  }, text), fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  }), children), button?.label && /*#__PURE__*/_react.default.createElement(CardButton, button))));
};

// Define propTypes;
TextCard.propTypes = {
  /** Object describing button properties */
  button: _propTypes.default.shape({
    /** Button label */
    label: _propTypes.default.string,
    /** Path, if using internal React Route */
    path: _propTypes.default.string,
    /** External URL, if not using a path */
    url: _propTypes.default.string,
    /** Button variant */
    variant: _propTypes.default.string
  }),
  /** Child content nodes, appears after content fragment */
  children: _propTypes.default.any,
  /** Custom style object for component */
  customContainerSx: _propTypes.default.object,
  /** Custom style object for content section (including image and text content) (Default Value: {}) */
  customContentSx: _propTypes.default.object,
  /** Custom style object for interior text and button content */
  customInnerContentSx: _propTypes.default.object,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Content Fragment ID, inserted after text property */
  fragmentId: _propTypes.default.string,
  /** Content text, inserted after heading */
  text: _propTypes.default.string,
  /** Heading title text */
  title: _propTypes.default.string,
  /** Card variant controlling text positioning (Default Value: "left") */
  variant: _propTypes.default.oneOf(["left", "center"]),
  /** If sublanding card, we need a color */
  subLandingColor: _propTypes.default.string,
  /** If a landing card, we need a color and an icon */
  landingStyles: _propTypes.default.shape({
    /** color to be used for the card*/
    color: _propTypes.default.string.isRequired,
    /** path to the icon */
    icon: _propTypes.default.string.isRequired
  })
};
CardButton.propTypes = {
  buttonTestId: _propTypes.default.string,
  customClassNames: _propTypes.default.string,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func,
  path: _propTypes.default.string,
  variant: _propTypes.default.string,
  url: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = TextCard;